import { Component, OnInit } from '@angular/core';
import { PageNavigationService } from '../../../shared/services/page-navigation.service';
import { LayoutService } from '../../../shared/services/layout.service';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

  constructor(
    private _pageNavigationService: PageNavigationService,
    private _layoutService: LayoutService    
     ) {}

  ngOnInit() {
    this._layoutService.setCurrentPage('privacy-policy');
  }
  goToLogin() {
    let vLink:any = ['login'];
    this._pageNavigationService.navigate(vLink);
}

}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/information/components/privacy/privacy.component.ts